















































import { Component, Vue, Watch } from 'vue-property-decorator';
import axios, { AxiosResponse } from 'axios';
const getUrl = require('bmh/url-with-param');
const { VUE_APP_FCREST: FCREST } = process.env;
const API = {
  integral: `${FCREST}/promotion/shang/activity/integral/`, // 积分设置
  activity: `${FCREST}/promotion/shang/statement/activity`, // 获取活动信息
};
const INTEGRAL_TYPE = {
  page_view_integral: 'page_view_integral',
  apply_integral: 'apply_integral',
  commodity_integral: 'commodity_integral',
};
function getActivityInfo(remote?: any) {
  remote = remote || {};
  return {
    apply_integral: remote.apply_integral || '',
    commodity_integral: remote.commodity_integral || '',
    page_view_integral: remote.page_view_integral || '',
  };
}

@Component
export default class ActivityIntegration extends Vue {
  activity_id: number = 0;
  activity_info: any = getActivityInfo();
  is_loading: boolean = false;
  get integralType() {
    return INTEGRAL_TYPE;
  }
  // 点击保存按钮
  async clickSaveBtn() {
    this.is_loading = true;
    const res = await this.$axios.put(`${API.integral}${this.activity_id}`, {
      page_view_integral: +this.activity_info.page_view_integral,
      apply_integral: +this.activity_info.apply_integral,
      commodity_integral: +this.activity_info.commodity_integral,
    });
    this.is_loading = false;
    await this.query();
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success('保存积分成功');
  }

  limitNum(integral_type: string) {
    this.activity_info[integral_type] =
      Math.floor(Math.abs(this.activity_info[integral_type])) || '';
  }

  async query() {
    this.is_loading = true;
    const res = await this.$axios.get(
      getUrl(API.activity, {
        activity_id: this.activity_id,
      }),
    );
    this.is_loading = false;
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.activity_info = getActivityInfo(res.data.data.activity_info);
  }

  async created() {
    this.activity_id = +this.$route.query.activity_id;
    await this.query();
  }
}
